import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="seal-field"
// A seal-number text input paired with an "Отсутствует" checkbox. Checking the
// box fills the input with the literal blank marker; editing the text away from
// it unchecks the box.
const BLANK_LABEL = "Отсутствует"

export default class extends Controller {
  static targets = ["input", "blank"]

  toggleBlank() {
    if (this.blankTarget.checked) {
      this.inputTarget.value = BLANK_LABEL
    } else if (this.inputTarget.value === BLANK_LABEL) {
      this.inputTarget.value = ""
    }
  }

  onInput() {
    if (this.inputTarget.value !== BLANK_LABEL) {
      this.blankTarget.checked = false
    }
  }
}
